export const imageWithWidth = (imgSrc: string, width: number): string => {
  const imageConfig = process.env.__NEXT_IMAGE_OPTS as any
  const params = ['f_auto', 'c_limit', `w_${width}`, 'q_auto']

  return imageConfig.path + params.join(',') + imgSrc
}
